"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var R = _interopRequireWildcard(require("ramda"));
var P = _interopRequireWildcard(require("@surge-global-engineering/rpdf-primitives"));
var _lineIndexAtHeight = _interopRequireDefault(require("./lineIndexAtHeight"));
var _heightAtLineIndex = _interopRequireDefault(require("./heightAtLineIndex"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var isType = R.propEq('type');
var isText = isType(P.Text);
var isImage = isType(P.Image);
var isTextInstance = isType(P.TextInstance);
var zero = R.always(0);
var getTop = R.pathOr(0, ['box', 'top']);
var getWidows = R.pathOr(2, ['props', 'widows']);
var getOrphans = R.pathOr(2, ['props', 'orphans']);

/**
 * compute line break index
 * @returns [number, number] where the second value represents # of lines dropped for orphan/widow protection
 */
var getLineBreak = function getLineBreak(node, height) {
  var top = getTop(node);
  var widows = getWidows(node);
  var orphans = getOrphans(node);
  var linesQuantity = node.lines.length;
  var slicedLine = (0, _lineIndexAtHeight.default)(node, height - top);
  if (slicedLine === 0) {
    return [0, 0];
  }
  if (linesQuantity < orphans) {
    return [linesQuantity - 1, 0];
  }
  if (slicedLine < orphans || linesQuantity < orphans + widows) {
    return [0, slicedLine];
  }
  if (linesQuantity === orphans + widows) {
    return [orphans, Math.max(0, slicedLine - orphans)];
  }
  if (linesQuantity - slicedLine < widows) {
    return [linesQuantity - widows, slicedLine - (linesQuantity - widows)];
  }
  return [slicedLine, 0];
};
var splitTextChildren = function splitTextChildren(node, splitIndex) {
  var current = [];
  var next = [];
  var accumulatedLength = 0;
  var _loop = function _loop() {
    var child = node.children[index];
    var localSplitIndex = Math.max(0, splitIndex - accumulatedLength);
    var length = 0;
    if (isTextInstance(child)) {
      length = child.value ? child.value.length : 0;
      if (length < localSplitIndex) {
        current.push(child);
      } else {
        // split the characters into two

        if (localSplitIndex > 0) {
          // there is data for the first part
          current.push((0, _extends2.default)({}, child, {
            value: child.value.slice(0, localSplitIndex)
          }));
        }
        if (length > localSplitIndex) {
          // there is data for the second part
          next.push((0, _extends2.default)({}, child, {
            value: child.value.slice(localSplitIndex)
          }));
        }
      }
    } else if (isText(child)) {
      var currentSubChildren;
      var nextSubChildren;
      var _splitTextChildren = splitTextChildren(child, localSplitIndex);
      currentSubChildren = _splitTextChildren[0];
      nextSubChildren = _splitTextChildren[1];
      length = _splitTextChildren[2];
      if (currentSubChildren.length) {
        var currentChild = R.evolve({
          style: R.evolve({
            marginBottom: zero,
            paddingBottom: zero,
            borderBottomWidth: zero,
            borderBottomLeftRadius: zero,
            borderBottomRightRadius: zero
          }),
          children: R.always(currentSubChildren)
        })(child);
        current.push(currentChild);
      }
      if (nextSubChildren.length) {
        var nextChild = R.compose(R.evolve({
          style: R.when(function () {
            return currentSubChildren.length;
          }, R.evolve({
            textIndent: zero // remove any text-indent
          }))
        }), R.evolve({
          style: R.evolve({
            marginTop: zero,
            paddingTop: zero,
            borderTopWidth: zero,
            borderTopLeftRadius: zero,
            borderTopRightRadius: zero
          }),
          children: R.always(nextSubChildren)
        }))(child);
        next.push(nextChild);
      }
    } else if (isImage(child)) {
      // an image takes up a single character in `lines`
      length = 1;
      if (length < localSplitIndex) {
        current.push(child);
      } else {
        next.push(child);
      }
    } else {
      throw new Error('Expected TEXT / TEXT_INSTANCE / IMAGE to split children');
    }
    accumulatedLength += length;
  };
  for (var index = 0; index < node.children.length; index += 1) {
    _loop();
  }
  return [current, next, accumulatedLength];
};

// Also receives contentArea in case it's needed
var splitText = function splitText(node, height) {
  var _getLineBreak = getLineBreak(node, height),
    slicedLineIndex = _getLineBreak[0],
    lineSkips = _getLineBreak[1];
  var currentHeight = (0, _heightAtLineIndex.default)(node, slicedLineIndex);
  var nextHeight = node.box.height - currentHeight;
  var _splitTextChildren2 = splitTextChildren(node, node.lines[slicedLineIndex].textBefore),
    currentChildren = _splitTextChildren2[0],
    nextChildren = _splitTextChildren2[1];

  // recalculate the `textBefore` property for the nextLines
  var textBefore = 0;
  var nextLines = node.lines.slice(slicedLineIndex).map(function (line) {
    var result = (0, _extends2.default)({}, line, {
      textBefore: textBefore
    });
    textBefore += line.string.length;
    return result;
  });
  var current = R.compose(R.assocPath(['props', 'lineSkips'], lineSkips), R.evolve({
    lines: R.slice(0, slicedLineIndex),
    style: R.evolve({
      marginBottom: zero,
      paddingBottom: zero,
      borderBottomWidth: zero,
      borderBottomLeftRadius: zero,
      borderBottomRightRadius: zero
    }),
    box: {
      height: R.always(currentHeight),
      borderBottomWidth: zero
    },
    children: R.always(currentChildren)
  }))(node);
  var next = R.compose(R.evolve({
    style: R.when(function () {
      return currentChildren.length;
    }, R.evolve({
      textIndent: zero // remove any text-indent
    }))
  }), R.evolve({
    lines: R.always(nextLines),
    style: R.evolve({
      marginTop: zero,
      paddingTop: zero,
      borderTopWidth: zero,
      borderTopLeftRadius: zero,
      borderTopRightRadius: zero
    }),
    box: {
      top: zero,
      height: R.always(nextHeight),
      borderTopWidth: zero
    },
    children: R.always(nextChildren)
  }))(node);
  return [current, next];
};
var _default = exports.default = splitText;